/* Copyright (c) 2024 Xperi. All Rights Reserved. */

import { MyShowsFilterItem } from 'client-code/myshows';

import type { TivoPayloadAction } from '../../core/tivo/tivo-redux-wrapper';
import { TMyShowsItemList } from '../../core/types';
import {
    RESET_MYSHOWS,
    SET_MY_SHOWS_CARET,
    SET_MY_SHOWS_FILTER,
    SET_MY_SHOWS_ITEM_LOADING,
    SET_MY_SHOWS_ITEMS,
    SET_MY_SHOWS_PAGE_LOADING,
    SET_MYSHOWS_ERROR,
} from './myshows.types';

export const setMyShowsItemsAction = (
    myShowsItems: TMyShowsItemList,
    page: number,
): TivoPayloadAction<{
    myShowsItems: TMyShowsItemList;
    page: number;
}> => ({
    type: SET_MY_SHOWS_ITEMS,
    payload: { myShowsItems, page },
});

export const setMyShowsFilterAction = (
    myShowsFilter: MyShowsFilterItem[],
    filteredIndex: number,
): TivoPayloadAction<{
    myShowsFilter: MyShowsFilterItem[];
    filteredIndex: number;
}> => ({
    type: SET_MY_SHOWS_FILTER,
    payload: { myShowsFilter, filteredIndex },
});

export const setMyShowsCaretVisibleAction = (
    isCaretVisible: boolean,
): TivoPayloadAction<{
    isCaretVisible: boolean;
}> => ({
    type: SET_MY_SHOWS_CARET,
    payload: { isCaretVisible },
});

export const setMyShowsItemsLoadingAction = (
    isItemsLoading: boolean,
): TivoPayloadAction<{
    isItemsLoading: boolean;
}> => ({
    type: SET_MY_SHOWS_ITEM_LOADING,
    payload: { isItemsLoading },
});

export const setMyShowsPageLoadingAction = (
    isPageLoading: boolean,
): TivoPayloadAction<{
    isPageLoading: boolean;
}> => ({
    type: SET_MY_SHOWS_PAGE_LOADING,
    payload: { isPageLoading },
});

export const resetMyShows = () => ({
    type: RESET_MYSHOWS,
});

export const setMyShowsErrorAction = (
    hasError: boolean,
    errorCode: string,
): TivoPayloadAction<{
    hasError: boolean;
    errorCode: string;
}> => ({
    type: SET_MYSHOWS_ERROR,
    payload: { hasError, errorCode },
});
